import { lastValueFrom } from 'rxjs';
import { PortalBaseService } from 'src/portal/portal-base.service';
import { PortalCredentialGroupResultModel, PortalCredentialModel } from './credentials.models';
import { Injectable } from '@angular/core';
import { downloadFile } from 'src/app/shared/utils/download-file-base64';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService extends PortalBaseService {
  public getCredentialGroups(): Promise<PortalCredentialGroupResultModel[]> {
    return lastValueFrom(this.get<PortalCredentialGroupResultModel[]>(`portal/credentials/group`));
  }

  public getInProgressCredentials(): Promise<PortalCredentialModel[]> {
    return lastValueFrom(this.get<PortalCredentialModel[]>(`portal/credentials/in-progress`));
  }

  public startRenewal(personCredentialId: string): Promise<string> {
    return lastValueFrom(this.post(`portal/credentials/${personCredentialId}/start-renewal`, {}));
  }

  public getRenewalAvailableCredentials(): Promise<PortalCredentialModel[]> {
    return lastValueFrom(this.get<PortalCredentialModel[]>('portal/credentials/renewal-available'));
  }

  public downloadCredentialPdf(entityCredentialId: string): void {
    lastValueFrom(this.get(`portal/credential-pdf/${entityCredentialId}`, true, true)).then(
      (result) => {
        downloadFile(result);
      },
      (error) => {
        this.openSnackBar(`Error downloading credential PDF ${error}`, false);
      }
    );
  }
}
